<template>
  <div class="common-limit">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        :model="queryParams"
        ref="queryForm"
        :inline="false"
        v-show="showSearch"
        label-width="80px"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="问题分类：" class="hide_input">
              <el-select
                clearable
                v-model="queryParams.questionType"
                placeholder="请选择问题分类"
                class="input"
                size="small"
              >
                <el-option
                  v-for="dict in dictData['question_type']"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                  >{{ dict.label }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="问题状态：" class="hide_input">
              <el-select
                clearable
                v-model="queryParams.questionStatus"
                placeholder="请选择问题状态"
                class="input"
                size="small"
              >
                <el-option label="正常" value="1">正常</el-option>
                <el-option label="停用" value="0">停用</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="问题标题：" prop="questionTitle">
              <el-input
                v-model="queryParams.questionTitle"
                style="width: 100%"
                placeholder="请输入公告标题"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="操作人员：" prop="createBy">
              <el-input
                v-model="queryParams.createBy"
                placeholder="请输入操作人员"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="操作时间：">
              <el-date-picker
                size="small"
                v-model="queryParams.time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col style="text-align: right;" :span="8">
            <el-button type="primary" size="mini" @click="handleQuery"
              >搜索</el-button
            >
            <el-button size="mini" @click="resetQuery">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <div style="overflow:hidden;margin: 0 0 8px 0;">
        <div style="float:left;">
          <el-button type="primary" size="small" @click="handleAdd"
            >新增</el-button
          >
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
      <el-table
        :data="noticeList"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="问题标题"
          align="center"
          prop="questionTitle"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleShowDetail(scope.row)">{{
              scope.row.questionTitle
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="问题分类"
          align="center"
          prop="questionType"
          :formatter="typeFormat"
          width="140"
        >
          <template slot-scope="scope">
            {{ dictMap["question_type"][scope.row.questionType] }}
          </template>
        </el-table-column>
        <el-table-column
          label="问题状态"
          align="center"
          prop="questionStatus"
          width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.questionStatus == "1" ? "正常" : "停用" }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作人员"
          align="center"
          prop="createBy"
          width="140"
        />
        <el-table-column
          label="操作时间"
          align="center"
          prop="createTime"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          width="100"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 添加或修改公告对话框 -->
    <el-dialog :close-on-click-modal="false"  
      :title="title"
      :visible.sync="open"
      width="800px"
      append-to-body
      class="notice-dialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-row class="notice-dia-row">
          <el-col>
            <el-form-item label="问题分类：" required prop="questionType">
              <el-select
                clearable
                v-model="form.questionType"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="dict in dictData['question_type']"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                  >{{ dict.label }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="问题标题：" prop="questionTitle">
              <el-input
                v-model="form.questionTitle"
                placeholder="请输入公告标题"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" style="margin-top: 20px">
            <el-form-item label="问题内容：" required>
              <CKEditor4
                v-if="open"
                v-model="form.content"
                @getCkEditorInstance="getEditor"
                :config="editorConfig"
                @open="openUploadDialog"
              ></CKEditor4>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="问题状态：" required>
              <el-radio-group v-model="form.questionStatus">
                <el-radio
                  v-for="dict in statusOptions"
                  :key="dict.dictValue"
                  :label="dict.dictValue"
                  >{{ dict.dictLabel }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"   :visible.sync="detailVisible" destroy-on-close>
      <div>
        <div
          style="font-size: 20px;border-bottom: 1px solid #EBEEF5; text-align: center;line-height: 40px"
        >
          {{ detailInfo.questionTitle }}
        </div>
        <div style="text-align: center; line-height: 40px">
          <span>更新时间: {{ detailInfo.createTime }}</span>
        </div>
        <div v-html="detailInfo.content"></div>
      </div>
      <div slot="footer">
        <el-button size="small" @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import {
  getHelp,
  deleteHelp,
  addHelp,
  updateHelp,
  getHelpList,
} from "@/api/sysSupport/help"
import CKEditor4 from "@/components/common/CKEditor"

export default {
  name: "Notice",
  components: {
    CKEditor4,
    Breadcrumb,
    LocalUpload,
    OnlineUpload,
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 公告表格数据
      noticeList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 类型数据字典
      statusOptions: [],
      // 状态数据字典
      typeOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        questionTitle: undefined,
        createBy: undefined,
        questionStatus: undefined,
        time: [],
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        questionTitle: [
          { required: true, message: "公告标题不能为空", trigger: "blur" },
        ],
        noticeType: [
          { required: true, message: "公告类型不能为空", trigger: "blur" },
        ],
      },
      editor: null,
      editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],
        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
      },
      localUploadData: {
        visible: false,
        editor: null,
      },
      onlineUploadData: {
        visible: false,
        editor: null,
      },
      detailVisible: false,
      detailInfo: {},
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    this.getList()
    this.getDicts("sys_notice_status").then((response) => {
      this.statusOptions = response.data
    })
    /* this.getDicts('sys_notice_type').then((response) => {
      this.typeOptions = response.data;
    }); */
  },
  methods: {
    /** 查询公告列表 */
    getList() {
      this.loading = true
      let params = Object.assign({}, this.queryParams)
      if (params.time && params.time.length > 0) {
        params.beginTime = params.time[0]
        params.endTime = params.time[1]
      }

      delete params["time"]
      getHelpList(params).then((response) => {
        this.noticeList = response.rows
        this.total = response.total
        this.loading = false
      })
    },
    // 公告状态字典翻译
    statusFormat(row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    // 公告状态字典翻译
    typeFormat(row, column) {
      return this.selectDictLabel(this.typeOptions, row.noticeType)
    },
    // 取消按钮
    cancel() {
      this.editor.destroy()
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.queryParams = {
        questionId: undefined,
        questionTitle: undefined,
        noticeType: undefined,
        content: undefined,
        status: "0",
        setTop: undefined,
        time: [],
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.reset()
      this.resetForm("queryForm")
      // this.handleQuery()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.questionId)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = "添加帮助"
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      const questionId = row.questionId || this.ids
      getHelp(questionId).then((response) => {
        this.open = true
        this.title = "修改公告"
        this.form = response.data
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.content = this.editor.getData()
          if (this.form.questionId != undefined) {
            updateHelp(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("修改成功")
                this.open = false
                this.getList()
              }
            })
          } else {
            addHelp(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("新增成功")
                this.open = false
                this.getList()
              }
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const questionIds = row.questionId || this.ids
      this.$confirm(
        '是否确认删除公告编号为"' + questionIds + '"的数据项?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function() {
          return deleteHelp(questionIds)
        })
        .then(() => {
          this.getList()
          this.msgSuccess("删除成功")
        })
        .catch(function() {})
    },
    getEditor(editor) {
      this.editor = this.localUploadData.editor = this.onlineUploadData.editor = editor
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
    handleShowDetail(row) {
      this.detailInfo = row
      this.detailVisible = true
    },
  },
}
</script>
<style scoped>
.notice-dia-row {
  margin: 10px;
}
.notice-dialog .el-dialog__footer {
  padding: 10px !important;
}
</style>
